import React, { useState } from 'react';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Icon from '@amzn/meridian/icon';
import plusTokens from '@amzn/meridian-tokens/base/icon/plus';
import { useTranslation } from 'src/arb-wrapper';
import { BuList } from './BuList';
import { BuFormModal } from './BuFormModal';
import type { BusinessUnitDto } from 'src/store/generated/leela-api-generated';

export const BuManagementPage: React.FC = () => {
  const { t } = useTranslation();
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [editingBu, setEditingBu] = useState<BusinessUnitDto | undefined>();

  return (
    <Column spacing="400">
      <Row alignmentHorizontal="justify" alignmentVertical="center">
        <Text type="h300">{t('bu_management_title')}</Text>
        <Button
          data-testid="bu-management-create-button"
          onClick={() => { setIsCreateOpen(true); }}
        >
          <Icon tokens={plusTokens} />
          {t('bu_management_create')}
        </Button>
      </Row>

      <BuList onEdit={setEditingBu} />

      <BuFormModal
        bu={editingBu}
        open={isCreateOpen || !!editingBu}
        onClose={() => { setIsCreateOpen(false); setEditingBu(undefined); }}
      />
    </Column>
  );
};
